import { createContext, useContext, useEffect, useState } from "react";
import { auth, db } from "../firebase";
import { onAuthStateChanged, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState();
  const [userDetails, setUserDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  // === FUNÇÃO DE LOGIN MELHORADA ===
  // Agora ela verifica o status ANTES de completar o login
  async function login(email, password) {
    // 1. Tenta autenticar no Firebase (Email/Senha)
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    // 2. Verifica se tem permissão no Banco de Dados
    try {
      const userDocRef = doc(db, "app_users", email.toLowerCase());
      const userDocSnap = await getDoc(userDocRef);

      // Checagem 1: Usuário existe na tabela de permissões?
      if (!userDocSnap.exists()) {
        await signOut(auth); // Desloga imediatamente
        throw new Error("NO_PERMISSION"); // Lança erro para o Login.js
      }

      const userData = userDocSnap.data();

      // Checagem 2: O Músico está ATIVO?
      if (userData.musicianId) {
        const musicianDocRef = doc(db, "musicians", userData.musicianId);
        const musicianSnap = await getDoc(musicianDocRef);
        
        if (musicianSnap.exists() && musicianSnap.data().isActive === false) {
           await signOut(auth); // Desloga imediatamente
           throw new Error("USER_INACTIVE"); // Lança erro para o Login.js
        }
      }

      // Se passou, retorna sucesso
      return userCredential;

    } catch (error) {
      // Se foi um erro nosso (lançado acima), repassa ele
      if (error.message === "NO_PERMISSION" || error.message === "USER_INACTIVE") {
        throw error;
      }
      // Se foi erro de rede ou banco, ignora e deixa entrar (ou trata como quiser)
      // Aqui optamos por deixar seguir se for só erro de leitura do banco pra não travar o app
      // mas o useEffect abaixo vai pegar depois.
    }
  }

  function logout() {
    setUserDetails(null);
    return signOut(auth);
  }

  // O useEffect continua aqui para proteger quem JÁ ESTAVA logado (sessão salva)
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const userDocRef = doc(db, "app_users", user.email.toLowerCase());
          const userDocSnap = await getDoc(userDocRef);
          
          if (!userDocSnap.exists()) {
            await signOut(auth);
            setCurrentUser(null);
            setUserDetails(null);
            setLoading(false);
            return;
          }

          const userData = userDocSnap.data();

          if (userData.musicianId) {
            const musicianDocRef = doc(db, "musicians", userData.musicianId);
            const musicianSnap = await getDoc(musicianDocRef);
            
            if (musicianSnap.exists() && musicianSnap.data().isActive === false) {
               await signOut(auth);
               setCurrentUser(null);
               setUserDetails(null);
               setLoading(false);
               return;
            }
          }

          setCurrentUser(user);
          setUserDetails(userData);

        } catch (error) {
          console.error("Erro permissão:", error);
          // Em caso de erro, mantemos o user básico do firebase para não travar loading
          setCurrentUser(user); 
        }
      } else {
        setCurrentUser(null);
        setUserDetails(null);
      }
      
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    userDetails,
    login,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}